import useInputChange from "hooks/useInputChange";
import { FormEvent, useState } from "react";
import { UserCreate } from "types/user.type";
import useStates from "hooks/useStates";
import useLgas from "hooks/useLgas";

interface Props {
  onSubmit: (record: UserCreate) => void;
  isLoading?: boolean;
  onCancel: () => void;
}
export default function AgentForm({ onSubmit, isLoading, onCancel }: Props) {
  const { state, onChange } = useInputChange<UserCreate>({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: "",
    role: "Agency",
    fullName: "",
    confirmPassword: "",
    state: "",
    lga: "",
  });
  const states = useStates();
  const lgas = useLgas(state.state);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();

    const payload: UserCreate = {
      ...state,
      confirmPassword: state.password,
    };
    onSubmit(payload);
  };

  return (
    <form action="#!" onSubmit={handleSubmit}>
      <div className="mb-3">
        <label className="inline-block mb-2 text-base font-medium">
          First Name
        </label>
        <input
          type="text"
          className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent placeholder:text-gray-400"
          placeholder="First Name"
          name="firstName"
          onChange={onChange}
          value={state.firstName}
          required
        />
      </div>
      <div className="mb-3">
        <label className="inline-block mb-2 text-base font-medium">
          Last Name
        </label>
        <input
          type="text"
          className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent placeholder:text-gray-400"
          placeholder="Last Name"
          name="lastName"
          onChange={onChange}
          value={state.lastName}
          required
        />
      </div>

      <div className="mb-3">
        <label className="inline-block mb-2 text-base font-medium">Email</label>
        <input
          type="email"
          className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent placeholder:text-gray-400"
          placeholder=""
          name="email"
          onChange={onChange}
          value={state.email}
          required
        />
      </div>
      <div className="mb-3">
        <label className="inline-block mb-2 text-base font-medium">
          Phone Number
        </label>
        <input
          type="text"
          className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent placeholder:text-gray-400"
          placeholder=""
          name="phoneNumber"
          onChange={onChange}
          value={state.phoneNumber}
          required
        />
      </div>

      <div className="mb-3">
        <label className="inline-block mb-2 text-base font-medium">State</label>
        <select
          className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent placeholder:text-gray-400"
          name="state"
          onChange={onChange}
          value={state.state}
        >
          <option value="">Select State</option>
          {states.map((state: any) => (
            <option key={state.value} value={state.value}>
              {state.label}
            </option>
          ))}
        </select>
      </div>

      <div className="mb-3">
        <label className="inline-block mb-2 text-base font-medium">LGA</label>
        <select
          className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent placeholder:text-gray-400"
          name="lga"
          onChange={onChange}
          value={state.lga}
        >
          <option value="">Select Lga</option>
          {lgas.map((state: any) => (
            <option key={state.value} value={state.value}>
              {state.label}
            </option>
          ))}
        </select>
      </div>

      <div className="mb-3">
        <label className="inline-block mb-2 text-base font-medium">
          Password
        </label>
        <input
          className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent placeholder:text-gray-400"
          placeholder="Password"
          name="password"
          onChange={onChange}
          value={state.password}
          required
        />
      </div>

      <div className="flex justify-end gap-2 mt-4">
        <button
          type="reset"
          data-modal-close="addDocuments"
          className="px-4 py-2 text-sm rounded-lg border border-gray-200 text-gray-600 hover:bg-gray-50 transition-colors"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 text-sm rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700 disabled:opacity-60 transition-colors"
        >
          {isLoading ? "Loading..." : "Create Agent"}
        </button>
      </div>
    </form>
  );
}
